/* Native details remain usable without JavaScript; the existing theme owns the mobile drawer. */
if (!customElements.get('fsm-navigation')) {
  customElements.define('fsm-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal: this.abort.signal});
      const groups = [...this.querySelectorAll('[data-fsm-top]')];
      const close = (except) => groups.forEach(g => { if (g !== except) g.open = false; });
      let viewportWidth = document.documentElement.clientWidth;
      groups.forEach(g => on(g, 'toggle', () => {
        if (g.open) close(g);
        this.closest('.header-section')?.classList.toggle('fsm-menu-open', groups.some(d => d.open));
        if (g.open && this.dataset.context === 'desktop') {
          const panel = g.querySelector('.fsm-mega');
          panel.style.maxHeight = Math.max(180, window.innerHeight - panel.getBoundingClientRect().top - 16) + 'px';
        }
      }));
      on(this, 'keydown', e => {
        const group = e.target.closest('[data-fsm-top]');
        if (e.key === 'Escape' && group?.open) {
          group.open = false; group.querySelector('summary').focus(); e.stopPropagation(); e.preventDefault();
        }
      });
      on(document, 'pointerdown', e => {if (!this.contains(e.target) && this.dataset.context === 'desktop') close();});
      // Safari can blur a summary on pointer-down without focusing the link.
      // Closing on focusout would hide that link before its click can fire.
      // Only close when focus actually arrives outside, or a pointer starts outside.
      on(document, 'focusin', e => {if (!this.contains(e.target) && this.dataset.context === 'desktop') close();});
      // Mobile browser bars can resize the viewport while a guest scrolls a submenu.
      // Keep the menu open on height-only changes.
      on(window, 'resize', () => {
        const nextWidth = document.documentElement.clientWidth;
        if (nextWidth !== viewportWidth) close();
        viewportWidth = nextWidth;
      });
      on(document, 'shopify:block:select', e => {
        if (!this.contains(e.target) || !this.getClientRects().length) return;
        const group = e.target.closest('[data-fsm-top]') || e.target.querySelector('[data-fsm-top]');
        if (group) group.open = true;
      });
    }
    disconnectedCallback() {this.abort?.abort();}
  });
}
